export const COMPACT_GLOBAL_NAVBAR_LOGO_SIZE_CLASS = "h-10 w-10";

export const COMPACT_GLOBAL_NAVBAR_AVATAR_SIZE_CLASS = "!h-10 !w-10";

export const COMPACT_GLOBAL_NAVBAR_ICON_SIZE_PX = 22;

export const COMPACT_GLOBAL_NAVBAR_ADD_ICON_SIZE_PX = Math.round(COMPACT_GLOBAL_NAVBAR_ICON_SIZE_PX * 1.2);

export const compactGlobalNavbarIconBoxClassName = "inline-flex size-10 shrink-0 items-center justify-center";

export const COMPACT_GLOBAL_TOOLBAR_CONTROL_HEIGHT_PX = 40;

export const compactGlobalToolbarControlClassName = "h-10 min-h-10";

export const globalToolbarBorderlessTriggerClassName = [
  "border-0 bg-transparent",
  "transition-colors",
  "hover:bg-sys-brand-on-surface/5",
  "active:bg-sys-brand-on-surface/10",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sys-brand-primary focus-visible:ring-offset-1"
].join(" ");
